module.exports = __webpack_public_path__ + "img/1528433208.07ddb4da.jpg";